import { render, staticRenderFns } from "./talk_tz.vue?vue&type=template&id=14ed47d8&scoped=true&"
import script from "./talk_tz.vue?vue&type=script&lang=js&"
export * from "./talk_tz.vue?vue&type=script&lang=js&"
import style0 from "./talk_tz.vue?vue&type=style&index=0&id=14ed47d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed47d8",
  null
  
)

export default component.exports